export var menuItems = {
  default: [
    { 
      "headTitle1": "General",
      "headTitle2": "Dashboards,Widgets & Layout.",
      "type": "headtitle"
    },
    { // dashboard
      "title": "Dashboard",
      "icon": "home",
      "type": "link",
      "path": "/dashboard",
      "active": true,
      "permission": { "action": "read", "subject": "Option" }
    },
    { // activity
      "title": "Activity",
      "icon": "activity",
      "type": "link",
      "active": false,
      "path": "/activity",
      "permission": { "action": "read", "subject": "Option" }
    },
    { // report
      "title": "Reports",
      "icon": "clipboard",
      "type": "sub",
      "active": false,
      "permission": { "action": "read", "subject": "Child" },
      "children":[
        {
          "path": "/dna-report/application",
          "title": "Application Status",
          "type": "link",
          "active":false,
          "permission": { "action": "read", "subject": "Child" }
        },
      ]
    },
    { // assessment
      "title": "Assessments",
      "icon": "book",
      "type": "sub",
      "active": false,
      "permission": { "action": "read", "subject": "Assessment" },
      "children": [
        {
          "type": "link",
          "path": "/assessments",
          "active": false,
          "title": "All Assessments",
          "permission": { "action": "read", "subject": "Assessment" }
        },
        {
          "path": '/assessments/age-group',
          "title": 'Age Group',
          "type": "link",
          "active": false,
          "permission": { "action": "read", "subject": "Term" }
        },
        {
          "type": "link",
          "path": "/assessments/import",
          "active": false,
          "title": "Import CSV",
          "permission": { "action": "manage", "subject": "Assessment" }
        }
      ]
    },
    { // intervention
      "title": "Interventions",
      "icon": "book",
      "type": "sub",
      "active": false,
      "permission": { "action": "read", "subject": "Intervention" },
      "children": [
        {
          "path": '/interventions',
          "title": 'All Interventions',
          "type": "link",
          "active": false,
          "permission": { "action": "read", "subject": "Intervention" }
        },
        {
          "path": '/interventions/age-group',
          "title": 'Age Group',
          "type": "link",
          "active": false,
          "permission": { "action": "read", "subject": "Term" }
        }
      ]
    },
    { // module
      "title": "Module",
      "icon": "book",
      "type": "link",
      "path": "/materials",
      "active": false,
      "permission": { "action": "read", "subject": "Material" }
    },
    { // ticket
      "title": "Tickets",
      "icon": "inbox",
      "type": "sub",
      "active": false,
      "permission": { "action": "read", "subject": "Ticket" },
      "children": [
        {
          "path": "/support",
          "title": 'Support Tickets',
          "type": "link",
          "active": false,
          "permission": { "action": "read", "subject": "Ticket" }
        },
        {
          "path": "/system-feedbacks",
          "title": 'System Feedbacks',
          "type": "link",
          "active": false,
          "permission": { "action": "read", "subject": "SystemFeedback" }
        },
        {
          "path": "/feedbacks",
          "title": 'Intervention Feedbacks',
          "type": "link",
          "active": false,
          "permission": { "action": "read", "subject": "InterventionFeedback" }
        }
      ]
    },
    { // subscription
      "title": "Subscription",
      "iconType": 'image',
      "icon": "subscribe.png",
      "type": "link",
      "path": "/subscription",
      "active": false,
      "permission": { "action": "read", "subject": "Package" }
    },
    { // subscription
      "title": "Payment History",
      "icon": "briefcase",
      "type": "link",
      "path": "/payments-history",
      "active": false,
      "permission": { "action": "read", "subject": "Payment" }
    },
    { // forum 
      "title": "Forum",
      "iconType": 'image',
      "icon": "chat.png",
      "type": "link",
      "path": '/forum',
      "active": false,
      "permission": { "action": "read", "subject": "Option" }
    },
    {  // faq
      "title": "FAQs",
      "icon": "rss",
      "type": "sub",
      "active": false,
      "permission": { "action": "read", "subject": "Faq" },
      "children":[
        {
          "path": "/faq",
          "title": "All FAQs",
          "type": "link",
          "active":false,
          "permission": { "action": "read", "subject": "Faq" }
        },
        {
          "path": "/faq/categories",
          "title": "FAQ Categories",
          "type": "link",
          "active":false,
          "permission": { "action": "read", "subject": "FaqCategory" }
        },
      ]
    },
    { // setting
      "title": "Settings",
      "icon": "settings",
      "type": "sub",
      "active": false,
      "permission": { "action": "read", "subject": "Option" },
      "children":[
        {
          "path": "/general-setting",
          "title": "General Setting",
          "type": "link",
          "active":false,
          "permission": { "action": "manage", "subject": "Option" }
        },
        {
          "path": "/invoice-setting",
          "title": "Invoice Setting",
          "type": "link",
          "active":false,
          "permission": { "action": "manage", "subject": "InvoiceSetting" }
        },
        {
          "path": "/registration-setting",
          "title": "Registration Setting",
          "type": "link",
          "active":false,
          "permission": { "action": "manage", "subject": "RegistrationSetting" }
        },
        {
          "path": "/reward-setting",
          "title": "Reward Setting",
          "type": "link",
          "active":false,
          "permission": { "action": "manage", "subject": "RewardSetting" }
        },
        {
          "path": "/dna-report/report",
          "title": "Profiling Setting",
          "type": "link",
          "active":false,
          "permission": { "action": "manage", "subject": "Package" }
        },
        {
          "title": "Report Status",
          "type": "link",
          "path": "/statuses",
          "active":false,
          "permission": { "action": "manage", "subject": "Status" }
        },
        {
          "path": "/feedback/configuration",
          "title": "Intervention Feedback Setting",
          "type": "link",
          "active":false,
          "permission": { "action": "manage", "subject": "InterventionFeedbackSetting" }
        },
        {
          "path": "/system-feedback/configuration",
          "title": "System Feedback Setting",
          "type": "link",
          "active":false,
          "permission": { "action": "manage", "subject": "SystemFeedbackSetting" }
        },
        {
          "path": "/backup-logs",
          "title": "Backup Logs",
          "type": "link",
          "active":false,
          "permission": { "action": "manage", "subject": "Option" }
        },
      ]
    },
    { // tools
      "title": "Tools",
      "icon": "tool",
      "type": "sub",
      "active": false,
      "permission": { "action": "read", "subject": "Option" },
      "children":[
        {
          "path": "/export/child",
          "title": "Export Child",
          "type": "link",
          "active":false,
          "permission": { "action": "export", "subject": "Child" }
        },
        {
          "path": "/reward-actions",
          "title": "Reward Action",
          "type": "link",
          "active":false,
          "permission": { "action": "manage", "subject": "RewardAction" }
        },
        {
          "path": "/notification-entity",
          "title": "Notification Entity",
          "type": "link",
          "active":false,
          "permission": { "action": "manage", "subject": "NotificationEntity" }
        },
      ]
    },
    {  // users
      "title": "Users",
      "icon": "users",
      "type": "sub",
      "active": false,
      "permission": { "action": "read", "subject": "User" },
      "children":[
        {
          "path": "/users",
          "title": "All User",
          "type": "link",
          "active":false,
          "permission": { "action": "read", "subject": "User" }
        },
        {
          "path": "/roles",
          "title": "User Roles",
          "type": "link",
          "active":false,
          "permission": { "action": "read", "subject": "Role" }
        },
      ]
    },
  ],
}